export const utils = {
    ssoLink: (token, destination, name, script = 'sso.php') => {

        if (!token) {
            window.open(destination);

            switch (name) {
                case 'infodesk':
                    window.open('https://gwportal.kangwon.ac.kr/user/login.face?ssoReturn=https://www.gwnu.ac.kr/sso/enpass_login.jsp?rtUrl=info');
                    break;
                case 'intra':
                    window.open('https://gwportal.kangwon.ac.kr/user/login.face?ssoReturn=https://lion.gwnu.ac.kr');
                    break;
                case 'webmail':
                    window.open('https://gwportal.kangwon.ac.kr/user/login.face?ssoReturn=https://mail.kangwon.ac.kr/sso/enpass/main');
                    break;
                case 'echarm':
                    window.open('https://eruri.kangwon.ac.kr/local/ubion/sso/sso.php');
                    break;
                case 'high':
                    window.open('https://high.kangwon.ac.kr');
                    break;
                case 'lib':
                    window.open('https://gwportal.kangwon.ac.kr/user/login.face?ssoReturn=https://gwportal.kangwon.ac.kr/portal/default/gwnu/empl/library.page');
                    break;
                case 'facility':
                    window.open('https://www.kangwon.ac.kr/sso/enpass/ko?url=/ko/bbs/758/list.do');
                    break;
            }

            return;
        }

        window.open(`/backend/${script}?token=${token}&destination=${destination}`);
    }
}